<template>
  <Command v-if="wpsClient.downloadLink" @click="download">
    <slot
      v-bind="{
        disabled: false,
        icon: 'file_download',
        label: t('moreOptions.download'),
        toolTip: t('moreOptions.download'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { posthogKeys } from "@/helpers/constants";
import { usePostHog } from "@/helpers/posthog";
import { useWpsClient } from "@/wps/client";

import Command from "../command";

const { t } = useI18n();
const { capture: capturePosthogEvent } = usePostHog();

const wpsClient = useWpsClient();

async function download() {
  capturePosthogEvent(posthogKeys.sampleDownload);
  window.open(wpsClient.downloadLink.href, "_blank");
}
</script>
